import { render } from "./UiTemplateReadOnly.pug?vue&type=template&id=9d533c2a&lang=pug"
import script from "./UiTemplateReadOnly.js?vue&type=script&lang=js"
export * from "./UiTemplateReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__